import React from 'react'
import { vectorSpeed, vectorSpeed1, indianPost } from '../../../images'
import { RunnerUpHeader, StatusCard, TableWork } from '../../../ui'
import LeftMenu from '../../AnalyticsModule/Left'
import '../index.css'
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'
const tableHeader = ['Speed Post No.', 'Date of Booking', 'Date of Delivery']
const TrackingEpbPin = () => {
  const epbDataRequest = []
  epbDataRequest.push({
    'Speed Post No.': 'NSE5756897909',
    'Date of Booking': '68 Central',
    'Date of Delivery': '403 Karol Bagh',
  })
  return (
    <LeftMenu>
      <div className="pin-download container box mt-4">
        <RunnerUpHeaderNew title={'Tracking of e-PB Booked by Post Office'} />
        <div className="row ml-1">
          <div className="col-md-3 status_width">
            <StatusCard
              title={'e-PB Transmitted'}
              count="5486"
              icon={vectorSpeed}
              bgColor={'#EF6C00'}
            />
          </div>
          <div className="col-md-3 status_width">
            <StatusCard
              title={'e-PB Booked (Speed Post)'}
              count="4400"
              icon={indianPost}
              bgColor={'#D50000'}
            />
          </div>
          <div className="col-md-3 status_width ">
            <StatusCard
              title={'e-PB Delivered'}
              count="3921"
              icon={vectorSpeed1}
              bgColor={'#2E7D32'}
            />
          </div>
        </div>
        <h6 className="ml-1">User List</h6>
        <TableWork
          id=""
          theadData={tableHeader}
          tbodyData={epbDataRequest}
          anchorTagName=""
          anchorTagclassName="viewDetails"
          emptyMessage="No data found"
          pageSize={10}
          pagination={true}
          paginationClass={'text-right p-0'}
        />
      </div>
    </LeftMenu>
  )
}
export default TrackingEpbPin
